import { IGAO } from '../../../../igao'

export function Tribal (): JSX.Element {
  return (
    <div className='main'>
      <IGAO
        path='tribal'
        withTopMargin={false}
      />
    </div>
  )
}
